import { SET_ART_WALL_SHAREABLE_URL } from './../const';

export default (artWallShareableUrl) => {
  return {
    type: SET_ART_WALL_SHAREABLE_URL,
    artWallShareableUrl: artWallShareableUrl
  }
};
